import {
  DecisionTableCase,
  DecisionTablePredicate,
} from "src/clients/flow-api";
import { DecisionTableNodeData } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";

export const predicateToSearchableField = (
  predicate: DecisionTablePredicate,
): SearchableField => ({
  id: predicate.id,
  value: predicate.value,
});

export const extractCaseFields = (
  caseItem: DecisionTableCase,
): SearchableField[] => {
  const caseName: SearchableField = { id: caseItem.id, value: caseItem.name };
  const predicates = Object.values(caseItem.predicates).map(
    predicateToSearchableField,
  );
  const effects = Object.values(caseItem.effects);
  return [caseName, ...predicates, ...effects];
};

export const extractDecisionTableFields = (
  data: DecisionTableNodeData,
): SearchableField[] => [
  ...data.predicate_fields,
  ...data.effect_fields,
  ...data.cases.flatMap(extractCaseFields),
  ...Object.values(data.fallback),
];
